export default {
    async searchAddress(address) {
        return fetch(process.env.VUE_APP_GOOGLE_MAPS_URL + '?key=' + process.env.VUE_APP_GOOGLE_MAPS_KEY + '&address=' + address, {
            method: 'GET',
        });
    },
}
